import { useEffect } from 'react';

import { useNavigate, useSearchParams } from 'react-router-dom';

import AuthService from '../../../services/AuthService';
import { saveAuthData } from '../../../helpers/authStorage';

export default function QuickAuthPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  // Redirect to / if token is not present
  useEffect(() => {
    if (!token) {
      navigate('/not-found');
    }
  }, [token, navigate]);

  // If token is present, verify it through the API and if it's valid log the user in
  useEffect(() => {
    const validateAndLogIn = async () => {
      try {
        const response = await AuthService.validateQuickAuthCode(token);
        saveAuthData({
          accessToken: response,
        });
        navigate('/');
      } catch (error) {
        console.error(error);
        navigate('/not-found');
      }
    };

    if (token) {
      validateAndLogIn();
    }
  }, [token, navigate]);

  return null;
}
